import { useEffect } from 'react';

function JotformFeedback() {
  useEffect(() => {
    if (document.getElementById('jotform-feedback-script')) return;

    const script1 = document.createElement('script');
    script1.src = 'https://cdn.jotfor.ms/s/static/latest/static/feedback2.js';
    script1.id = 'jotform-feedback-script';
    script1.async = true;

    script1.onload = () => {
      const componentID = new window.JotformFeedback({
        type: false,
        width: 700,
        height: 500,
        fontColor: "#FFFFFF",
        background: "#F59202",
        isCardForm: false,
        formId: "260416533462049",
        buttonText: "Feedback",
        buttonSide: "right",
        buttonAlign: "center",
        base: "https://form.jotform.com/",
      }).componentID;

      const embedScript = document.createElement('script');
      embedScript.src =
        'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
      embedScript.async = true;
      embedScript.onload = () => {
        window.jotformEmbedHandler(
          `iframe[id='${componentID}_iframe']`,
          "https://form.jotform.com/"
        );
      };

      document.body.appendChild(embedScript);
    };

    document.body.appendChild(script1);
  }, []);

  return null; 
}

export default JotformFeedback;